module.exports = __webpack_public_path__ + "static/media/eye.87e7dc08.svg";